<div class="dealer-preferred-confirm-save" [ngSwitch]="status">

    <div *ngSwitchCase="'processing'">
        <ox-loading></ox-loading>
    </div>
    <div class="text-center" *ngSwitchCase="''">
        <p class="gb-headline2 mb-3" role="heading" aria-level="2" [translate]="'locateDealer_makeMyPreferred_prompt1'" [translateParams]="{dealerName: dealer.name}"></p>
        <p class="mb-2 gb-body1" [translate]="'locateDealer_makeMyPreferred_prompt2'"></p>

        <span   [trackLink]="'Dealer:CancelMakePreferred'"
                [trackDelay]="'true'"
                [trackType]="'o'"
                [prop10]="'find dealer:button:Cancel'">
            <button class="gb-secondary-button mb-2"
                    (click)="cancel()"
                    [translate]="'locateDealer_makeMyPreferred_cancelBtn'">
            </button>
        </span>

        <span [trackLink]="'Dealer:SaveMakePreferred'"
              [trackDelay]="'true'"
              [trackType]="'o'"
              [prop10]="'find dealer:button:Save'">
            <button class="gb-primary-button"
                    (click)="save()"
                    [translate]="'locateDealer_makeMyPreferred_saveBtn'">
            </button>
        </span>
    </div>

</div>
